import ThemeFeature from "./themeFeature";

class DisableEmptyLink extends ThemeFeature {
    /**
     * Disabling browser from jumping up top when clicking empty (#) links
     * @param {string} selector
     */
    enable(selector = 'a[href="#"]') {
        // todo throw error on dev mode
        const emptyLinks = Array.from(document.querySelectorAll(selector));
        emptyLinks.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
            });
        });
    }
}

export default DisableEmptyLink;